import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Paid Actors',
		description:
			'Hire professional actors to pretend to be regular people. They keep breaking into song.'
	},
	{
		name: 'Mirror Room',
		description:
			'Replace all walls with mirrors. Now one person looks like a crowd.'
	},
	{
		name: 'Virtual Reality Sessions',
		description: 'Conduct focus groups in VR where everyone appears as a cat.'
	},
	{
		name: 'Time Loop Groups',
		description:
			"Make participants repeat the same focus group forever. They haven't noticed yet."
	},
	{
		name: 'Parallel Universe Feedback',
		description:
			'Gather opinions from alternate reality versions of the focus group.'
	},
	{
		name: 'Quantum Focus',
		description:
			'Participants simultaneously agree and disagree with everything.'
	},
	{
		name: 'Existential Questions Only',
		description:
			'Replace all campaign questions with deep philosophical inquiries.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Focus Groups'],
	departments[DepartmentIds['Focus Groups']].basePrice * 3,
	UpgradeIds.FgrExponent1
)

export default array
